<template>
<div class="modal verify-password-modal"
     :class="{ 'is-active': show }"
>
    <div class="modal-background" @click="hideModal"></div>
    <div class="modal-card">

        <header class="modal-card-head">
            <p class="modal-card-title">
                {{ title || trans.title }}
            </p>
            <button class="delete" aria-label="close"
                    @click="hideModal"
            ></button>
        </header>

        <section class="modal-card-body">
            <div class="content">
                <div class="field is-horizontal field-label-container">
                    <label for="password" class="field-label is-normal">
                        {{ trans.password }}
                    </label>

                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="password"
                                    type="password"
                                    class="input"
                                    name="password"
                                    autocomplete="current-password"
                                    required
                                    :class="{ 'is-danger': errors.password }"
                                    v-model="form.password"
                                    @keyup.enter="submit"
                                >
                            </div>
                            <p v-show="errors.password" class="help is-danger">
                                {{ errors.password }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer class="modal-card-foot">
            <button class="button is-info"
                :class="{ 'is-loading': isLoading }"
                @click="submit"
            >
                {{ trans.confirm_button }}
            </button>
            <button class="button" @click="hideModal">
                {{ trans.cancel }}
            </button>
            <p v-show="errors.unexpected" class="help is-danger">
                {{ errors.unexpected }}
            </p>
        </footer>
    </div>
</div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin';
    import { mapState, mapActions } from 'vuex';

    export default {
        mixins: [axiosForm],
        props: {
            title: String || null,
        },
        data() {
            return {
                form: {
                    password: null,
                },
            }
        },
        computed: {
            ...mapState('passwordVerify', ['show']),
        },
        methods: {
            /**
             * Обработчик ответа axios запроса формы
             * @param response {object} - ответ сервера
             *
             * @returns void
             */
            postResultHandler(response) {
                if (response.data.result) {
                    this.setPassword(this.form.password);
                    this.form.password = null;
                    this.hideModal();
                }
            },

            /**
             * Методы vuex-модуля `passwordVerify` (модального окна
             *  подтверждение пароля)
             *  hidePasswordVerifyModal - скрытие модального окна подтверждения пароля
             *  setPassword - установка текущего пароля в хранилище vuex
             */
            ...mapActions('passwordVerify',
                {
                    hideModal: 'hidePasswordVerifyModal',
                    setPassword: 'setPassword',
                }
            ),
        }
    }
</script>
